// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title--accordion[data-v-c50550f8] {\n  text-transform: none;\n}", ""]);
// Exports
module.exports = exports;
